// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3uj2g","messages":"Chat_messages__1QHqF","dateDivider":"Chat_dateDivider__3Iwz0"};